import QuoteTrackingTable from "@/components/QuoteTrackingTable/quoteTrackingTable.component";
import BasePage from "@/infrastructure/BasePage/basePage.component";
import React from "react";
import { useTranslation } from "react-i18next";

type PageQuotationProps = {
  // TODO: add props here
};

const PageQuotation: React.FC<PageQuotationProps> = (props) => {
  const { t } = useTranslation();
  return (
    <BasePage currPage="quotation">
      <div className="h-full overflow-y-auto">
        <h1 className="text-center text-3xl font-bold">
          {t("Quotation Management")}
        </h1>
        <QuoteTrackingTable />
      </div>
    </BasePage>
  );
};

export default PageQuotation;
